module.exports = __webpack_public_path__ + "static/media/Dev.be9ef84f.svg";